import axios from 'axios';

const axiosInstance = axios.create();

axiosInstance.interceptors.request.use(
    (config) => {
        const referer = window.location.origin + window.location.pathname;
        config.headers['Referer'] = document.referrer || referer;
        console.log('Referer:', {header: config.headers['Referer'], documentReferrer: document.referrer, referer});
        return config;
    },
    (error) => {
        return Promise.reject(error instanceof Error ? error : new Error(String(error)));
    }
);
export default axiosInstance;